var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({ref:"copyButton",attrs:{"width":_vm.width,"height":_vm.height,"rounded":"","icon":"","color":_vm.color},on:{"click":function($event){return _vm.copyToClipboard(_vm.url)}}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.isCopy ? 'mdi-check' : 'mdi-content-copy'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }